import { Notification, variants } from '@eti/components';
import { Text } from '@etg/wings';
import useSelfServiceRebooking from '../self-service-rebooking/useSelfServiceRebooking';

const RebookingBanner = () => {
  const { translations } = useSelfServiceRebooking();
  const titleText = translations.find((entry) => entry?.key === 'INFORMATION_BOX_TITLE')
    ?.translation;
  const descriptionText = translations.find((entry) => entry?.key === 'INFORMATION_BOX_CONTENT')
    ?.translation;

  return (
    <Notification dataTestId="rebookingBanner" title={titleText} variant={variants.INFORMATION}>
      <Text asHtml>{descriptionText}</Text>
    </Notification>
  );
};

export default RebookingBanner;
